<template>
    <!-- TODO - EPIC-1000 EPIC : Soap migration -->
    <b-row class="soap-details">
        <b-col xl="4" md="4" sm="4">
            <patient-profile
                ref="patientProfile"
                :patient="soapDetails.patient"
            />
        </b-col>
        <b-col xl="4" md="4" sm="4">
            <b-table-simple borderless>
                <b-tbody>
                    <b-tr class="row">
                        <b-th class="col-4">Title:</b-th>
                        <b-td class="col-8">
                            {{ soapDetails.title || soapDetails.name_only }}
                        </b-td>
                    </b-tr>
                    <b-tr class="row">
                        <b-th class="col-4">Date:</b-th>
                        <b-td class="col-8">
                            {{ _carbonDateDisplay(soapDetails.date) }}
                        </b-td>
                    </b-tr>
                    <b-tr class="row">
                        <b-th class="col-4">Status:</b-th>
                        <b-td class="col-8">
                            {{ soapStatus }}
                        </b-td> </b-tr
                    ><b-tr class="row">
                        <b-th class="col-4">Complaint:</b-th>
                        <b-td class="col-8">
                            {{ soapDetails.complaint }}
                        </b-td> </b-tr
                    ><b-tr class="row">
                        <b-th class="col-4">Provider:</b-th>
                        <b-td class="col-8">
                            <b-td>
                                {{ provider }}
                            </b-td></b-td
                        > </b-tr
                    ><b-tr class="row">
                        <b-th class="col-4">Referred By:</b-th>
                        <b-td class="col-8">
                            <div v-if="soapDetails.referred_by">
                                <b-link
                                    v-if="
                                        soapDetails.referred_by.referral_type ==
                                        'client'
                                    "
                                    :to="{
                                        name: 'client_profile',
                                        params: {
                                            id:
                                                soapDetails.referred_by
                                                    .encoded_id
                                        }
                                    }"
                                >
                                    {{ soapDetails.referred_by.label }}
                                </b-link>
                                <b-link
                                    v-else-if="
                                        soapDetails.referred_by.referral_type ==
                                        'contact'
                                    "
                                    :to="{
                                        name: 'contact_actor',
                                        params: {
                                            id:
                                                soapDetails.referred_by
                                                    .encoded_id
                                        }
                                    }"
                                >
                                    {{ soapDetails.referred_by.label }}
                                </b-link>
                                <b-link
                                    v-else-if="
                                        soapDetails.referred_by.referral_type ==
                                        'company'
                                    "
                                    :to="{
                                        name: 'contact_company',
                                        params: {
                                            id:
                                                soapDetails.referred_by
                                                    .encoded_id
                                        }
                                    }"
                                >
                                    {{ soapDetails.referred_by.label }}
                                </b-link>
                                <span
                                    v-else-if="
                                        soapDetails.referred_by.referral_type ==
                                        'campaign'
                                    "
                                >
                                    {{
                                        soapDetails.referred_by &&
                                        soapDetails.referred_by.title
                                            ? soapDetails.referred_by.title
                                            : ""
                                    }}
                                </span>
                            </div>
                        </b-td></b-tr
                    ><b-tr class="row">
                        <b-th class="col-4">Last Updated:</b-th>
                        <b-td class="col-8">
                            {{ _carbonDateDisplay(soapDetails.update_at) }}
                        </b-td> </b-tr
                    ><b-tr class="row">
                        <b-th class="col-4">Updated By:</b-th>
                        <b-td class="col-8">
                            {{ updatedBy }}
                        </b-td>
                    </b-tr>
                    <b-tr class="row">
                        <b-th class="col-4">Billing:</b-th>
                        <b-td class="col-8">
                            <template v-if="soapDetails.invoices">
                                <div
                                    v-for="invEst in soapDetails.invoices"
                                    :key="invEst.id"
                                >
                                    <estimate-link
                                        v-if="
                                            invEst.is_estimate &&
                                            invEst.encoded_id
                                        "
                                        :estimate="invEst"
                                    />
                                    <invoice-link
                                        v-else
                                        :invoice="invEst"
                                        :newTab="false"
                                    />

                                    ({{ invEst.total_amount }})
                                </div>
                            </template>
                        </b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </b-col>
        <b-col xl="4" md="4" sm="4" v-if="reminders.length > 0">
            <patient-reminder ref="patientReminder" :reminders="reminders" />
        </b-col>
    </b-row>
</template>
<script>
/**
 * @name SoapDisplay
 * @see apps/application/views/staff/patient/soap/view.php
 * @see apps/application/models/orm/TblSoap.php
 */

import InvoiceLink from "@/components/commons/invoice-link";
import EstimateLink from "@/components/commons/estimate-link";
import PatientProfile from "@/components/patient/sub/patient-profile";
import PatientReminder from "@/components/patient/sub/patient-reminder";

export default {
    mixins: [],
    components: {
        InvoiceLink,
        EstimateLink,
        PatientProfile,
        PatientReminder
    },
    data() {
        return {};
    },
    computed: {
        soapId() {
            return this.soapDetails ? this.soapDetails.id : null;
        },
        soapDetails() {
            return this.$store.getters["soap/soapDetails"];
        },
        reminders() {
            return this.$store.getters["patient/reminders"];
        },
        isLocked() {
            return this.$store.getters["soap/isLocked"];
        },
        soapStatus() {
            //Based on application/models/orm/TblSoap.php@isLocked
            if (this.isLocked) {
                return `Locked (${this._carbonDateDisplay(
                    this.soapDetails.update_at
                )})`;
            } else {
                return "In Process";
            }
        },
        provider() {
            let provider = "None";
            if (this.soapDetails.default_provider) {
                provider = this.soapDetails.default_provider.display_name;
            } else if (this.soapDetails.prescribed_by) {
                provider =
                    this.soapDetails.prescribed_by.label ||
                    this.soapDetails.prescribed_by.display_name;

                if (
                    !this.isOwner(this.soapDetails.business_id) &&
                    this.soapDetails.business
                ) {
                    provider = `${provider} (${this.soapDetails.business.name})`;
                }
            }
            return provider;
        },
        updatedBy() {
            let updatedBy = this.soapDetails.last_audit_by?.label || null;
            if (
                updatedBy &&
                !this.isOwner(this.soapDetails.business_id) &&
                this.soapDetails.business
            ) {
                updatedBy = `${updatedBy} (${this.soapDetails.business.name})`;
            }
            return updatedBy;
        }
    }
};
</script>
<style type="text/css" lang="scss" scoped>
.soap-details th,
.soap-details td {
    padding: 0px !important;
    line-height: 35px;
}
.soap-details tr {
    padding-left: 1.5rem !important;
}
</style>
